export interface ICertifiedOrganizationDetails {
    scId: string;
    certifiedOrganizationEmail: string[];
    certifiedOrganizationLicenseNo: string;
    certifiedOrganizationName: string;
    certifiedOrganizationTeId: string;
    certifiedOrganizationNameNative: string;
    certifiedOrganizationContactFirstName: string;
    certifiedOrganizationContactLastName: string;
    certifiedOrganizationWebsite: string;
    certifiedOrganizationPublicEmail: string;
    certifiedOrganizationAddress1: string;
    certifiedOrganizationAddress2: string;
    certifiedOrganizationAddress3: string;
    certifiedOrganizationPostcode: string;
    certifiedOrganizationTown: string;
    certifiedOrganizationStateOrProvince: string;
    certifiedOrganizationCountryOrArea: string;
}

export const mapPayload = (jsonData: any, scId: string, countries?: any, states?: any) => {
    return {
        scId: scId,
        certifiedOrganizationEmail: Array.isArray(jsonData.certifiedOrganizationEmail)
            ? jsonData.certifiedOrganizationEmail
            : typeof jsonData.certifiedOrganizationEmail === 'string'
                ? jsonData.certifiedOrganizationEmail.split(',').map((email: string) => email.trim())
                : [],
        certifiedOrganizationLicenseNo: jsonData.certifiedOrganizationLicenseNo,
        certifiedOrganizationName: jsonData.certifiedOrganizationName,
        certifiedOrganizationTeId: jsonData.certifiedOrganizationTeId,
        certifiedOrganizationNameNative: jsonData.certifiedOrganizationNameNative,
        certifiedOrganizationContactFirstName: jsonData.certifiedOrganizationContactFirstName,
        certifiedOrganizationContactLastName: jsonData.certifiedOrganizationContactLastName,
        certifiedOrganizationWebsite: jsonData.certifiedOrganizationWebsite,
        certifiedOrganizationPublicEmail: jsonData.certifiedOrganizationPublicEmail || '',
        certifiedOrganizationAddress1: jsonData.certifiedOrganizationAddress1,
        certifiedOrganizationAddress2: jsonData.certifiedOrganizationAddress2,
        certifiedOrganizationAddress3: jsonData.certifiedOrganizationAddress3,
        // certifiedOrganizationPostcode: jsonData.certifiedOrganizationPostcode,
        certifiedOrganizationPostcode: jsonData.certifiedOrganizationPostcode || "641023",
        certifiedOrganizationTown: jsonData.certifiedOrganizationTown || "town",
        // certifiedOrganizationStateOrProvince: jsonData.certifiedOrganizationStateOrProvince,
        certifiedOrganizationStateOrProvince: jsonData.certifiedOrganizationStateOrProvince,
        certifiedOrganizationStateOrProvinceDescription: states.length > 0 ? states.find((option: any) => option.value === (jsonData.certifiedOrganizationStateOrProvince ?? ""))?.label.trim() ?? "" : "",
        // certifiedOrganizationCountryOrArea: jsonData.certifiedOrganizationCountryOrArea || 'st',
        certifiedOrganizationCountryOrArea: jsonData.certifiedOrganizationCountryOrArea,
        certifiedOrganizationCountryOrAreaDescription: countries.length > 0 ? countries.find((option: any) => option.value === (jsonData.certifiedOrganizationCountryOrArea ?? ""))?.label.trim() ?? "" : "",
    }
}

export const initialCertifiedOrganizationDetails: ICertifiedOrganizationDetails = {
    scId: '',
    certifiedOrganizationEmail: [],
    certifiedOrganizationLicenseNo: '',
    certifiedOrganizationName: '',
    certifiedOrganizationTeId: '',
    certifiedOrganizationNameNative: '',
    certifiedOrganizationContactFirstName: '',
    certifiedOrganizationContactLastName: '',
    certifiedOrganizationWebsite: '',
    certifiedOrganizationPublicEmail: 'N',
    certifiedOrganizationAddress1: '',
    certifiedOrganizationAddress2: '',
    certifiedOrganizationAddress3: '',
    certifiedOrganizationPostcode: '',
    certifiedOrganizationTown: '',
    certifiedOrganizationStateOrProvince: '',
    certifiedOrganizationCountryOrArea: '',
};

export const mapCertifiedOrganizationDetailsApiResponseToInitialValues = (response: any) => {
    return {
        scId: response?.scId || '',
        certifiedOrganizationEmail: Array.isArray(response?.certifiedOrganizationEmail)
            ? response.certifiedOrganizationEmail
            : [],
        certifiedOrganizationLicenseNo: response?.certifiedOrganizationLicenseNo || '',
        certifiedOrganizationName: response?.certifiedOrganizationName || '',
        certifiedOrganizationTeId: response?.certifiedOrganizationTeId || '',
        certifiedOrganizationNameNative: response?.certifiedOrganizationNameNative || '',
        certifiedOrganizationContactFirstName: response?.certifiedOrganizationContactFirstName || '',
        certifiedOrganizationContactLastName: response?.certifiedOrganizationContactLastName || '',
        certifiedOrganizationWebsite: response?.certifiedOrganizationWebsite || '',
        certifiedOrganizationPublicEmail: response?.certifiedOrganizationPublicEmail || 'N',
        certifiedOrganizationAddress1: response?.certifiedOrganizationAddress1 || '',
        certifiedOrganizationAddress2: response?.certifiedOrganizationAddress2 || '',
        certifiedOrganizationAddress3: response?.certifiedOrganizationAddress3 || '',
        certifiedOrganizationPostcode: response?.certifiedOrganizationPostcode || '',
        certifiedOrganizationTown: response?.certifiedOrganizationTown || '',
        certifiedOrganizationStateOrProvince: response?.certifiedOrganizationStateOrProvince || '',
        certifiedOrganizationCountryOrArea: response?.certifiedOrganizationCountryOrArea || '',
    };
};
